import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SectionLabel } from "./Shared";
import { CLIENTS } from "../config/siteConfig";

const FEATURED = CLIENTS.slice(0, 9);

export const ClientsShowcase = () => (
  <section className="bg-[#F7F7F5] py-24 md:py-36" data-testid="clients-showcase-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="max-w-3xl mb-14">
        <SectionLabel>Our Clients</SectionLabel>
        <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.03] tracking-tight text-[#111111]">
          Delivered Close to 400 Projects <span className="text-[#C62828]">Across the Globe.</span>
        </h2>
        <p className="font-body text-[#555] text-lg leading-relaxed mt-8">
          We believe in creating partnerships based on honesty and true connection. That&apos;s why some of the
          biggest companies stayed with us for years.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {FEATURED.map((c) => (
          <article
            key={c.name}
            data-testid={`featured-client-${c.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            className="bg-white border border-black/10 rounded-sm p-7 hover:border-[#C62828] hover:shadow-[0_18px_40px_-24px_rgba(198,40,40,0.5)] transition-all duration-400 flex flex-col"
          >
            <div className="h-20 mb-5 flex items-center justify-center bg-[#F7F7F5] rounded-sm border border-black/5 px-4">
              {c.logo ? (
                <img
                  src={c.logo}
                  alt={`${c.name} logo`}
                  className="max-h-14 max-w-full object-contain"
                  loading="lazy"
                />
              ) : (
                <span className="font-accent uppercase tracking-widest text-xs text-[#999]">INRISOFT</span>
              )}
            </div>
            <h3 className="font-body font-600 text-lg text-[#111111] mb-3">{c.name}</h3>
            <p className="font-body text-[#555] text-sm leading-relaxed line-clamp-4">{c.desc}</p>
          </article>
        ))}
      </div>

      <Link
        to="/clients"
        data-testid="clients-showcase-cta"
        className="group inline-flex items-center gap-2 mt-12 font-accent uppercase tracking-widest text-sm text-[#111111] hover:text-[#C62828] transition-colors"
      >
        View All Clients
        <ArrowRight size={17} className="transition-transform group-hover:translate-x-1" />
      </Link>
    </div>
  </section>
);

export default ClientsShowcase;
